import { render, staticRenderFns } from "./ManufactureTemplateDownload.vue?vue&type=template&id=1712465f"
import script from "./ManufactureTemplateDownload.vue?vue&type=script&lang=js"
export * from "./ManufactureTemplateDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports